import React, { useState } from 'react';
import Modal from '../../Modal';
import AvailabilityEditor from './AvailabilityEditor';
import ExceptionsManager from './ExceptionsManager';

/**
 * Groups the two resource-scoped availability tools — the weekly-hours editor
 * and the blackout/opening manager — into one modal launched from the resource
 * list. Each inner tool is independently mountable; this is just the container.
 */
const TABS = [
    { key: 'weekly', label: 'Weekly hours' },
    { key: 'exceptions', label: 'Blackouts & openings' },
];

export default function ResourceAvailabilityModal({ resource, onSaved, onClose }) {
    const [tab, setTab] = useState('weekly');

    return (
        <Modal
            isOpen
            onClose={onClose}
            title={`Availability · ${resource.name}`}
            size="large"
            className="booking-modal booking-availability-modal"
        >
            <div className="booking-subtabs" role="tablist">
                {TABS.map(t => (
                    <button
                        key={t.key}
                        type="button"
                        role="tab"
                        aria-selected={tab === t.key}
                        className={`booking-subtab${tab === t.key ? ' is-active' : ''}`}
                        onClick={() => setTab(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {tab === 'weekly' ? (
                <AvailabilityEditor resource={resource} onSaved={onSaved} />
            ) : (
                <ExceptionsManager resource={resource} />
            )}
        </Modal>
    );
}
